export const convertListStatusToEntityStatus = (status: string) => {
	switch (status) {
		case "ARCHIVED":
			return "ACTIVE";
		case "OCCURRING":
			return "DISABLED";
		case "WORK_IN_PROGRESS":
			return "INFORMATION";
		case "PERMANENTLY_BROKEN":
			return "DISMISSED";
		default:
			return status;
	}
};
